module.exports = __webpack_public_path__ + "static/media/clone.4338c7c5.svg";